import { UserFragmentFragment } from "src/graphql/anti-fraud/__generated__/graphql";
import { User } from "src/types/user";

export const mapToUser = (fragment: UserFragmentFragment): User => ({
  id: fragment.id,
  email: fragment.email,
  firstName: fragment.firstName,
  lastName: fragment.lastName,
  name: fragment.name,
});
